
























































import {Component, PropSync} from "vue-property-decorator";
import {DatePickerWings, FastDateDetailWings, FilterWings, SelectWings} from "@/components";
import {Action, Getter} from "vuex-class";
import {ReportFilter} from "@/store/reports/types";
import FilterSelectedItemWings from "@/components/Filter/FilterSelectedItemWings.vue";
import BaseFilter from "@/components/Filter/BaseFilter";
import {beginningOfCurrentDay, currentDateEnd} from "@/utils/date-util";
import {DateTime} from "luxon";
import {notifyError, notifyWarning} from '@/utils/notify-helper';

@Component({
  components: {
    DatePickerWings,
    FastDateDetailWings,
    FilterSelectedItemWings,
    FilterWings,
    SelectWings,
  },
  filters: {
    date(value: string) {
      return DateTime.fromISO(value).toFormat('dd.LL.yyyy HH:mm')
    }
  }
})
export default class ReportsFilter extends BaseFilter<ReportFilter> {
  @PropSync('show') is_show!: boolean;
  @Getter("reportStatusList") statusList: any;
  @Action("getReports") actionGetReports: any;

  defaultFilter():ReportFilter {
    return {
      date_from: beginningOfCurrentDay(),
      date_to: currentDateEnd(),
      status: null,
    }
  }

  async onFilteredAction() {
    try {
      const resp = await this.actionGetReports(this.filter);
      if (resp.status === 204) {
        notifyWarning()
      }
    } catch(err) {
      notifyError(err)
    }
  }
}
